import { jsxs, jsx } from "react/jsx-runtime";
const IconTitleSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M20 10h-6a1 1 0 1 0 0 2h2v7a1 1 0 1 0 2 0v-7h2a1 1 0 1 0 0-2Z" }),
      /* @__PURE__ */ jsx("path", { d: "M14 6a1 1 0 1 0 0-2H4a1 1 0 1 0 0 2h4v13a1 1 0 1 0 2 0V6h4Z" })
    ]
  }
);
export {
  IconTitleSvg
};
